import React, { FC } from 'react';
import { Outlet } from 'react-router-dom';
import { useReactiveVar } from '@apollo/client';

import SignIn from '../SignIn';

import { isLoggedInVar } from 'graphql/cache';

const AuthRequiredInline: FC = () => {
  const isLoggedIn = useReactiveVar(isLoggedInVar);

  return isLoggedIn ? <Outlet /> : <SignIn />;
};

export default AuthRequiredInline;
